module.exports = "../../app/cells/components/menu_cell.rb";